/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as LinksIndexRouteImport } from './routes/links/index'
import { Route as FeedsIndexRouteImport } from './routes/feeds/index'
import { Route as UsersMeRouteImport } from './routes/users/me'
import { Route as LinksLinkIdRouteImport } from './routes/links/$linkId'
import { Route as FeedsFeedIdRouteImport } from './routes/feeds/$feedId'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const LinksIndexRoute = LinksIndexRouteImport.update({
  id: '/links/',
  path: '/links/',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedsIndexRoute = FeedsIndexRouteImport.update({
  id: '/feeds/',
  path: '/feeds/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersMeRoute = UsersMeRouteImport.update({
  id: '/users/me',
  path: '/users/me',
  getParentRoute: () => rootRouteImport,
} as any)
const LinksLinkIdRoute = LinksLinkIdRouteImport.update({
  id: '/links/$linkId',
  path: '/links/$linkId',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedsFeedIdRoute = FeedsFeedIdRouteImport.update({
  id: '/feeds/$feedId',
  path: '/feeds/$feedId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/logout': typeof LogoutRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/feeds/$feedId': typeof FeedsFeedIdRoute
  '/links/$linkId': typeof LinksLinkIdRoute
  '/users/me': typeof UsersMeRoute
  '/feeds': typeof FeedsIndexRoute
  '/links': typeof LinksIndexRoute
  '/users': typeof UsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/logout': typeof LogoutRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/feeds/$feedId': typeof FeedsFeedIdRoute
  '/links/$linkId': typeof LinksLinkIdRoute
  '/users/me': typeof UsersMeRoute
  '/feeds': typeof FeedsIndexRoute
  '/links': typeof LinksIndexRoute
  '/users': typeof UsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/logout': typeof LogoutRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/feeds/$feedId': typeof FeedsFeedIdRoute
  '/links/$linkId': typeof LinksLinkIdRoute
  '/users/me': typeof UsersMeRoute
  '/feeds/': typeof FeedsIndexRoute
  '/links/': typeof LinksIndexRoute
  '/users/': typeof UsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/logout'
    | '/auth/callback'
    | '/auth/login'
    | '/feeds/$feedId'
    | '/links/$linkId'
    | '/users/me'
    | '/feeds'
    | '/links'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/logout'
    | '/auth/callback'
    | '/auth/login'
    | '/feeds/$feedId'
    | '/links/$linkId'
    | '/users/me'
    | '/feeds'
    | '/links'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/logout'
    | '/auth/callback'
    | '/auth/login'
    | '/feeds/$feedId'
    | '/links/$linkId'
    | '/users/me'
    | '/feeds/'
    | '/links/'
    | '/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LogoutRoute: typeof LogoutRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthLoginRoute: typeof AuthLoginRoute
  FeedsFeedIdRoute: typeof FeedsFeedIdRoute
  LinksLinkIdRoute: typeof LinksLinkIdRoute
  UsersMeRoute: typeof UsersMeRoute
  FeedsIndexRoute: typeof FeedsIndexRoute
  LinksIndexRoute: typeof LinksIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/links/': {
      id: '/links/'
      path: '/links'
      fullPath: '/links'
      preLoaderRoute: typeof LinksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feeds/': {
      id: '/feeds/'
      path: '/feeds'
      fullPath: '/feeds'
      preLoaderRoute: typeof FeedsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/me': {
      id: '/users/me'
      path: '/users/me'
      fullPath: '/users/me'
      preLoaderRoute: typeof UsersMeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/links/$linkId': {
      id: '/links/$linkId'
      path: '/links/$linkId'
      fullPath: '/links/$linkId'
      preLoaderRoute: typeof LinksLinkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feeds/$feedId': {
      id: '/feeds/$feedId'
      path: '/feeds/$feedId'
      fullPath: '/feeds/$feedId'
      preLoaderRoute: typeof FeedsFeedIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LogoutRoute: LogoutRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthLoginRoute: AuthLoginRoute,
  FeedsFeedIdRoute: FeedsFeedIdRoute,
  LinksLinkIdRoute: LinksLinkIdRoute,
  UsersMeRoute: UsersMeRoute,
  FeedsIndexRoute: FeedsIndexRoute,
  LinksIndexRoute: LinksIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
